module.exports = __webpack_public_path__ + "static/Future-of-Work-Template-Articles-1280-x-720-2-800x450-9f04482a6215d11b8ce4dc88f0ae12cb.png";